import React, { Component, Fragment } from "react";
import { Route, Routes } from "react-router-dom";
import { withTranslation } from "react-i18next";
import {
  Loading,
  withAuthentication,
  withRouter,
  HandleLoading,
} from "cw-styleguide-react";
import axios from "axios";
import config from "./config";
import i18n from "./i18n";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { route } from "./routes";
import StepController from "./controllers/StepController";
import AnimalsController from "./controllers/AnimalsController";
import LandingController from "./controllers/LandingController";
import ResultsController from "./controllers/ResultsController";
import AppView from "./AppView";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      questions: [],
      answers: [],
      animals: {
        ENFP: {
          en: "clownfish",
          cy: "pysgodyn-clown",
        },
        INFP: {
          en: "seal",
          cy: "morlo",
        },
        ENFJ: {
          en: "dolphin",
          cy: "ddolffin",
        },
        INFJ: {
          en: "seahorse",
          cy: "morfarch",
        },
        ISFJ: {
          en: "koala-bear",
          cy: "arth-coala",
        },
        ISTJ: {
          en: "polar-bear",
          cy: "arth-wen",
        },
        ESTJ: {
          en: "black-bear",
          cy: "arth-ddu",
        },
        ESFJ: {
          en: "panda",
          cy: "panda",
        },
        ENTJ: {
          en: "eagle",
          cy: "eryr",
        },
        INTJ: {
          en: "barn-owl",
          cy: "tylluan-wen",
        },
        INTP: {
          en: "tawny-owl",
          cy: "tylluan-frech",
        },
        ENTP: {
          en: "falcon",
          cy: "hebog",
        },
        ESFP: {
          en: "lion",
          cy: "llew",
        },
        ESTP: {
          en: "panther",
          cy: "panther",
        },
        ISTP: {
          en: "tiger",
          cy: "teigr",
        },
        ISFP: {
          en: "cat",
          cy: "cath",
        },
      },
      questionsLoaded: false,
      messages: new Set(),
    };

    this.setAnswers = this.setAnswers.bind(this);
    this.resetAnswers = this.resetAnswers.bind(this);
  }

  componentDidMount() {
    if (
      this.props.authentication.hasHandledRedirectPromise &&
      this.isUnauthorised()
    ) {
      setTimeout(() => this.props.navigate(route("landing")));
    }

    this.getQuestions().then((response) => {
      console.log("Debug: questions response", response);

      this.setState({
        questions: response.data.questions,
        // Create the 2 dimensional answers array from the questions [['']]
        answers: response.data.questions.map((question) =>
          question.answers.map(() => "")
        ),
        questionsLoaded: true,
      }).catch((error) => {
        console.error("Debug: error fetching questions details:", error);
      });
    });

    // Crate the animals object for mapping codes to slugs.
    // this.getSummary("en")
    //   .then((response) => {
    //     const animals = this.state.animals;

    //     response.data.forEach((animal) => {
    //       animals[animal.code] = {};
    //       animals[animal.code]["en"] = animal.slug;
    //     });
    //   })
    //   .then(
    //     this.getSummary("cy").then((response) => {
    //       const animals = this.state.animals;

    //       response.data.forEach((animal) => {
    //         animals[animal.code]["cy"] = animal.slug;
    //       });

    //       console.log("animals", animals);
    //     })
    //   );
    console.log("animals", this.state.animals);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.authentication.hasHandledRedirectPromise !==
      prevProps.authentication.hasHandledRedirectPromise
    ) {
      if (
        this.props.authentication.hasHandledRedirectPromise &&
        this.isUnauthorised()
      ) {
        setTimeout(() => this.props.navigate(route("landing")));
      }
    }
  }

  isUnauthorised() {
    let unauthorised = [
      route("step1"),
      route("step2"),
      route("step3"),
      route("step4"),
      // route('result', { tab: this.props.t('results.tabs.personality.slug') }),
      // route('result', { tab: this.props.t('results.tabs.job.slug') }),
      // route('result', { tab: this.props.t('results.tabs.education.slug') })
    ];

    return (
      this.props.authentication.hasHandledRedirectPromise &&
      unauthorised.includes(this.props.location.pathname)
    );
  }

  async getQuestions() {
    return axios
      .get(config.endpoints.questions, {
        headers: {
          "Accept-Language": i18n.language,
        },
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async getAnimal(slug) {
    return axios.get(config.endpoints.type + "/" + slug, {
      headers: {
        "Accept-Language": i18n.language,
      },
    });
  }

  async getSummary(language = i18n.language) {
    return axios
      .get(config.endpoints.summary, {
        headers: {
          "Accept-Language": language,
        },
      })
      .catch((error) => {
        console.log(error);
      });
  }

  setAnswers(step, answers) {
    const answersCopy = this.state.answers;

    answersCopy[step] = answers;

    this.setState({
      answers: answersCopy,
    });
  }

  resetAnswers() {
    this.setState({
      answers: this.state.questions.map((question) =>
        question.answers.map(() => "")
      ),
    });
  }

  render() {
    if (this.state.questionsLoaded === false) {
      return <Loading text={this.props.t("styleguide:forms.loading")} />;
    }

    return (
      <AppView
        {...this.state}
        resetAnswers={this.resetAnswers}
        setAnswers={this.setAnswers}
        getSummary={this.getSummary}
        getAnimal={this.getAnimal}
        getQuestions={this.getQuestions}
      />
    );
  }
}

export default withAuthentication(withRouter(withTranslation("local")(App)));
